import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Users, Building2, ClipboardList, Inbox, Receipt, FileCheck2, LogOut } from 'lucide-react';
import { useAuth } from '@/features/auth/auth.store';
import { cn } from '@/lib/utils';
import { UpdateLeiste } from '@/shared/pwa/UpdateLeiste';

const NAV = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/kunden', label: 'Kunden', icon: Users },
  { to: '/objekte', label: 'Objekte', icon: Building2 },
  { to: '/auftraege', label: 'Aufträge', icon: ClipboardList },
  { to: '/meldungen', label: 'Meldungen', icon: Inbox },
  { to: '/zusatzleistungen', label: 'Zusatzleistungen', icon: Receipt },
  { to: '/berichte', label: 'Berichte', icon: FileCheck2 },
];

export function AppShell() {
  const user = useAuth((s) => s.user);
  const logout = useAuth((s) => s.logout);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/anmelden', { replace: true });
  };

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Im Fluss, nicht als Overlay: schiebt den Inhalt nach unten, statt
          Bedienelemente zu verdecken (ADR-033). */}
      <UpdateLeiste />
      <header className="sticky top-0 z-10 border-b border-slate-200 bg-white">
        <div className="mx-auto flex h-14 max-w-6xl items-center justify-between px-4">
          <span className="text-lg font-bold text-brand-700">ProofFlow</span>
          <div className="flex items-center gap-3">
            <span className="hidden text-sm text-slate-600 sm:inline">{user?.email}</span>
            <button
              onClick={handleLogout}
              className="inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-sm text-slate-600 hover:bg-slate-100"
            >
              <LogOut className="h-4 w-4" />
              <span className="hidden sm:inline">Abmelden</span>
            </button>
          </div>
        </div>
      </header>

      <div className="mx-auto max-w-6xl px-4 py-6">
        <div className="flex gap-6">
          <nav className="hidden w-52 shrink-0 md:block">
            <ul className="space-y-1">
              {NAV.map((item) => (
                <li key={item.to}>
                  <NavLink
                    to={item.to}
                    end={item.end}
                    className={({ isActive }) =>
                      cn(
                        'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium',
                        isActive ? 'bg-brand-700 text-white' : 'text-slate-700 hover:bg-slate-100',
                      )
                    }
                  >
                    <item.icon className="h-4 w-4" />
                    {item.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>
          <main className="min-w-0 flex-1">
            <Outlet />
          </main>
        </div>
      </div>

      {/* Mobile-Navigation unten */}
      <nav className="fixed bottom-0 left-0 right-0 z-10 border-t border-slate-200 bg-white md:hidden">
        <ul className="flex">
          {NAV.slice(0, 5).map((item) => (
            <li key={item.to} className="flex-1">
              <NavLink
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  cn(
                    'flex flex-col items-center gap-0.5 py-2 text-[10px] font-medium',
                    isActive ? 'text-brand-700' : 'text-slate-500',
                  )
                }
              >
                <item.icon className="h-5 w-5" />
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}
